module.exports = __webpack_public_path__ + "img/5.61e7e628.svg";